const { sanitizeDocument, sanitizeCep, sanitizePhone } = require('@/utils/nfeSanitizers');

const CONSUMER_DESTINATION_FINAL = 1;

let destinationNFeInitial = {
  cnpjorcpfDestination: "",
  idDestination: "",
  nameDestination: "",
  publicPlaceDestination: "",
  numberDestination: "",
  complementDestination: "",
  districtDestination: "",
  codeCountyDestination: "",
  nameCountyDestination: "",
  ufDestination: "",
  zipCodeDestination: "",
  codeCountryDestination: "",
  nameCountryDestination: "",
  numberPhoneDestination: "",
  recipientIEIndicatorDestination: "",
  stateRegistrationDestinationNumber: "",
  stateSuframaRegistration: "",
  stateMunicipalRegistrationDestination: "",
  emailDestination: "",
};

async function execute(sales) {
  try {
    let clientIdentify = sales.client.id;
    if (clientIdentify == CONSUMER_DESTINATION_FINAL) {
      return await mounterDestinationFinalConsumer();
    }
    return await mounterConsumerDestinationIdentify(sales);
  } catch (error) {
    return error;
  }
}

async function mounterConsumerDestinationIdentify(sales) {
  let destinationNFe = { ...destinationNFeInitial };
  const isLegalPeople = sales.client.physicalpeople === null;
  const legalpeople = isLegalPeople ? sales.client.legalpeople : null;

  destinationNFe.cnpjorcpfDestination = sanitizeDocument(
    isLegalPeople ? legalpeople.cnpj : sales.client.physicalpeople.cpf
  );
  destinationNFe.idDestination = "";
  destinationNFe.nameDestination = isLegalPeople
    ? legalpeople.socialName
    : sales.client.physicalpeople.name + " " + sales.client.physicalpeople.lastName;
  destinationNFe.publicPlaceDestination = sales.client.address[0].street;
  destinationNFe.numberDestination = sales.client.address[0].number;
  destinationNFe.complementDestination = sales.client.address[0].complement;
  destinationNFe.districtDestination = sales.client.address[0].district;
  destinationNFe.codeCountyDestination = String(sales.client.address[0].city_id);
  destinationNFe.nameCountyDestination = sales.client.address[0].state;
  destinationNFe.ufDestination = sales.client.address[0].state;
  destinationNFe.zipCodeDestination = sanitizeCep(sales.client.address[0].cep);
  destinationNFe.codeCountryDestination = "1058";
  destinationNFe.nameCountryDestination = "BRASIL";
  destinationNFe.numberPhoneDestination = sanitizePhone(sales.client.contacts[0].phone);
  destinationNFe.stateSuframaRegistration = "";
  destinationNFe.stateMunicipalRegistrationDestination = "";
  destinationNFe.emailDestination = sales.client.contacts[0].primaryEmail;

  applyIeIndicator(destinationNFe, legalpeople);

  return destinationNFe;
}

async function mounterDestinationFinalConsumer() {
  let destinationNFe = { ...destinationNFeInitial };
  destinationNFe.recipientIEIndicatorDestination = "9";
  destinationNFe.stateRegistrationDestinationNumber = "";
  return destinationNFe;
}

function applyIeIndicator(destinationNFe, legalpeople) {
  if (!legalpeople) {
    // Pessoa Física
    destinationNFe.recipientIEIndicatorDestination = "9";
    destinationNFe.stateRegistrationDestinationNumber = "";
    return;
  }

  const ie = legalpeople.stateRegistration;

  if (!ie || ie === "ISENTO") {
    destinationNFe.recipientIEIndicatorDestination = "2";
    destinationNFe.stateRegistrationDestinationNumber = "";
    return;
  }

  destinationNFe.recipientIEIndicatorDestination = "1";
  destinationNFe.stateRegistrationDestinationNumber = ie;
}

module.exports = { execute };
